import { useEffect, useState } from "react";
import { getJigsawUserInfo } from "../../../../common/api/jigsaw/methods";
import { useHomeContextIsExploreReady } from "../../homeContext";

export default function useJigsawUser() {
  const [jigsawUser, setJigsawUser] = useState<Jigsaw.UserData>();
  const [error, setError] = useState<Error>();
  const exploreReady = useHomeContextIsExploreReady();

  useEffect(() => {
    if (exploreReady) {
      getJigsawUserInfo()
        .then((response) => {
          if (response.status === "ok") {
            setJigsawUser(response.data);
          } else {
            throw new Error(`Jigsaw User status, ${response.status}`);
          }
        })
        .catch((error: Error) => {
          setError(error);
        });
    }

    if (error) {
      throw error;
    }
  }, [exploreReady, error]);

  return jigsawUser;
}
